import { createIcon } from '@chakra-ui/icons';

export const DocumentsIcon = createIcon({
  displayName: 'DocumentsIcon',
  viewBox: '0 0 18 20',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 1.46957 0.218818 0.960859 0.608317 0.585786C0.997815 0.210714 1.52609 0 2.07692 0L13.4405 0L18 4.39067V18C18 18.5304 17.7812 19.0391 17.3917 19.4142C17.0022 19.7893 16.4739 20 15.9231 20H2.07692C1.52609 20 0.997815 19.7893 0.608317 19.4142C0.218818 19.0391 0 18.5304 0 18V2ZM4.15385 5.32933H13.8462V6.66267H4.15385V5.32933ZM13.8462 9.32667H4.15385V10.66H13.8462V9.32667ZM13.8462 13.3333H4.15385V14.6667H13.8462V13.3333Z"
      fill="currentColor"
    />
  ),
});
